import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrcamentosEPacotesRoutingModule } from './orcamentos-e-pacotes-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OrcamentosEPacotesRoutingModule
  ]
})
export class OrcamentosEPacotesModule { }
